<template>
  <div class="user-box">
    <ul class="select-option">
      <li>
        <el-input
          v-model="username"
          placeholder="请输入用户名"
          class="select-input"
          @keyup.enter.native="search"
        />
      </li>
      <li>
        <el-button type="primary" icon="el-icon-search" @click.stop="search">
          查询
        </el-button>
      </li>
      <li v-if="checkPermission('sys:user:save', permList)">
        <el-button type="primary" icon="iconfont icon-plus" @click.stop="add">
          增加
        </el-button>
      </li>
      <li v-if="checkPermission('sys:user:update', permList)">
        <el-button type="primary" icon="iconfont icon-xiugai" @click.stop="revise">
          修改
        </el-button>
      </li>
      <li v-if="checkPermission('sys:user:delete', permList)">
        <el-button type="primary" icon="iconfont icon-delet" @click.stop="del">
          删除
        </el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column
        label="序号"
        type="index"
        :index="indexMethod"
        width="50"
        align="center"
      />
      <el-table-column type="selection" width="50" align="center" />
      <el-table-column label="用户ID" prop="userId" />
      <el-table-column prop="username" label="用户名" />
      <el-table-column
        width="120"
        prop="deptName"
        label="所属部门"
        show-overflow-tooltip
      />
      <el-table-column prop="email" label="邮箱" show-overflow-tooltip />
      <el-table-column prop="mobile" label="手机号" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="70" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success" label="正常" effect="dark">
            正常
          </el-tag>
          <el-tag v-else type="danger" label="禁用" effect="dark">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      loading: false,
      limit: 10,
      pageIndex: 1,
      username: '',
      tableData: {},
      selectRows: []
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId: function() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    this.$emit('setCurrentMenu', '管理员管理')
    this.getUserList(this.limit, this.pageIndex, this.username)
  },

  methods: {
    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    getUserList(limit, pageIndex, username) {
      const vm = this
      vm.axios
        .get(this.homePath() + '/sys/user/list', {
          params: {
            limit: limit,
            page: pageIndex,
            username: username
          }
        })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.tableData = data.page
          } else if (data.status === '100000') {
            this.$alert(data.message, '提示', {
              confirmButtonText: '确定',
              callback() {
                vm.$router.push('/index/user')
              }
            })
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.getUserList(this.limit, this.pageIndex, this.username)
    },
    add() {
      this.$router.push('/index/adduser')
    },
    revise() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })

        return
      }

      this.$router.push('/index/reviseuser/' + vm.selectRows[0].userId)
    },
    del() {
      const vm = this
      vm.$confirm('确定要删除选中的记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          vm.axios
            .post(vm.homePath() + '/sys/user/delete', vm.selectRowsId)
            .then((response) => {
              if (response.data.status === '000000') {
                vm.$message({
                  type: 'success',
                  message: '删除成功!'
                })

                vm.getUserList(vm.limit, vm.pageIndex, vm.username)
              } else {
                console.log(response.data.message)
              }
            })
            .catch((error) => console.log(error))
        })
        .catch(() => {
          vm.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    pageChange(val) {
      this.pageIndex = val
      this.getUserList(this.limit, this.pageIndex, this.username)
    }
  }
}
</script>
